'use client';

import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';
import { useEffect } from 'react';

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  const isProduction = process.env.NODE_ENV === 'production';

  useEffect(() => {
    if (!isProduction) return;

    const key = process.env.NEXT_PUBLIC_POSTHOG_KEY;
    if (!key) return;

    // Ingest via Next.js proxy rewrites; avoid any direct external connections
    posthog.init(key, {
      api_host: '/ingest',
      capture_pageview: false,
      capture_pageleave: true,
      autocapture: true,
      persistence: 'localStorage+cookie',
      person_profiles: 'identified_only',
      capture_exceptions: true,
      debug: false,
      advanced_disable_decide: true,
      disable_session_recording: true,
    });
  }, [isProduction]);

  // Return children directly in development, wrap with PostHog provider in production
  if (!isProduction) {
    return <>{children}</>;
  }

  return <PHProvider client={posthog}>{children}</PHProvider>;
}
